const formatMonthByDateObj = (date: Date, locale = 'en-us') =>
  date.toLocaleString(locale, { month: 'long' })

const formatMonthByString = (dateString: string, locale = 'en-us') =>
  new Date(dateString).toLocaleString(locale, { month: 'long' })

const formatDateByDateObj = (date: Date, locale = 'en-us') =>
  date.toLocaleString(locale, {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  })

const formatDateByString = (dateString: string, locale = 'en-us') =>
  new Date(dateString).toLocaleString(locale, {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  })

const formatMonthAndDayByString = (dateString: string, locale = 'en-us') =>
  new Date(dateString).toLocaleString(locale, {
    month: 'long',
    day: 'numeric',
  })

const formatDateByStringNumeric = (
  dateString: string,
  locale = 'en-us',
  timeZone?: string,
) =>
  new Date(dateString).toLocaleString(locale, {
    month: 'numeric',
    day: 'numeric',
    year: 'numeric',
    timeZone,
  })

const getLocalDate = (date: string): Date => {
  const timezoneDiff = new Date(date).getTimezoneOffset() * 60000
  return new Date(new Date(date).getTime() + timezoneDiff)
}

export {
  formatDateByDateObj,
  formatDateByString,
  formatMonthAndDayByString,
  formatMonthByDateObj,
  formatMonthByString,
  formatDateByStringNumeric,
  getLocalDate,
}
